/**
 * PurposeStrip.tsx — the "what this screen is for / what you do here" card
 * shown at the top of every Conversion Architect phase.
 */

import React from 'react';
import { c, font, eyebrow } from './tokens';

interface PurposeStripProps {
  forText: string;
  doText: string;
  oracleText: string;
}

const PurposeStrip: React.FC<PurposeStripProps> = ({ forText, doText, oracleText }) => (
  <div
    style={{
      background: c.card,
      border: `1px solid ${c.border}`,
      borderLeft: `4px solid ${c.accent}`,
      borderRadius: 10,
      padding: '16px 20px',
      marginBottom: 16,
      fontFamily: font.ui,
    }}
  >
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 22 }}>
      <div>
        <div style={{ ...eyebrow, marginBottom: 6 }}>What this screen is for</div>
        <div style={{ fontSize: 13, color: c.textBody, lineHeight: 1.55 }}>{forText}</div>
      </div>
      <div>
        <div style={{ ...eyebrow, marginBottom: 6 }}>What you do here</div>
        <div style={{ fontSize: 13, color: c.textBody, lineHeight: 1.55 }}>{doText}</div>
      </div>
    </div>
    <div
      style={{
        marginTop: 12,
        paddingTop: 10,
        borderTop: `1px solid ${c.hairline}`,
        fontSize: 11.5,
        color: c.textSecondary,
      }}
    >
      {oracleText}
    </div>
  </div>
);

export default PurposeStrip;
